<template>
  <v-container fluid tag="section">
    <material-wizard
      v-model="tab"
      :title="title"
      subtitle="Preencha as Informações para a ferramenta Obrigações Especiais."
      :available-steps="tabsLiberadas"
      :tabs="tabs"
      class="mx-auto"
      :loading="loading"
      :wizzard-mixins-on="true"
      max-width="1000"
      @click:next="nextStep()"
      @click:prev="prevStep()"
    >
      <wizard-tabs ref="wizzardTabsREF" :tab="tab" @step-observer="updateTabStatus($event)" @update:tab="tab = $event" />
    </material-wizard>
  </v-container>
</template>
  
<script>
  import ObrigacoesEspeciaisService from '@/services/ObrigacoesEspeciaisService';
  import wizardMixins from '@/mixins/wizardMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      MaterialWizard: () => import('@/components/base/MaterialWizard.vue'),
      WizardTabs: () => import('@/components/obrigacoesEspeciais/WizardTabs.vue')
    },
    mixins: [wizardMixins, dateFormatterMixins],

    data: () => ({
      tabs: ['Arquivos SDI', 'Parâmetros'],
      loading: false
    }),

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Obrigações Especiais' : 'Adicionar Obrigações Especiais';
      }
    },

    created() {
      this.$store.dispatch('clearObrigacoesEspeciais');

      if (this.$route.params.id) this.getById(this.$route.params.id);
    },

    methods: {
      getById(id) {
        ObrigacoesEspeciaisService.getById(id)
          .then((response) => {
            this.setDataInVuex(response.data.data);
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar obrigações especiais.', '', { position: 'topRight' });
          });
      },

      save() {
        const id = this.$route.params.id ?? null;
        const data = this.$refs.wizzardTabsREF.exportData();
        this.loading = true;

        ObrigacoesEspeciaisService.salvar(data, id)
          .then(() => {
            this.$toast.success('Obrigações Especiais salva com sucesso.', '', { position: 'topRight' });
            this.$router.replace({ name: 'Obrigações Especiais Histórico' });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao salvar Obrigações Especiais.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },

      setDataInVuex(item) {
        this.$store.dispatch('setObrigacoesEspeciais', {
          /* Campos etapa 1 */
          titulo: item.titulo,
          uploadedFiles: JSON.parse(item.files),
          //Inserir arquivos

          /* Campos etapa 2 */
          dataBase: this.getOnlyDateIgnoringTimestamp(item.data_base),
          dataProjetada: this.getOnlyDateIgnoringTimestamp(item.data_projetada),
          taxaMediaDep: item.taxa_media_dep,
          possuiDevolucoes: item.possui_devolucoes,
          possuiKit: item.possui_kit,
          percentuais: JSON.parse(item.percentuais),
          valores: JSON.parse(item.valores),
          arquivoDelimitador: item.arquivo_delimitador,
          arquivoInvolucro: item.arquivo_involucro,
          arquivoEscape: item.arquivo_escape
        });

        this.$forceUpdate();
      }
    }
  };
</script>
  